<template>
  <div class="app-container view-container">
    <BjDivider right-fixed
      >{{ $t('SettingIndexesList.details.title') }}
      <template slot="right">
        <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submit('form')">{{ $t('saveText') }}</el-button>
      </template>
    </BjDivider>

    <el-form ref="form" :model="form" :rules="rules" label-width="200px">
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.indexCode')" prop="indexCode">
            <BjInput v-model="form.indexCode" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.remark')" prop="remark">
            <BjInput v-model="form.remark" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="enabledFlag">
            <el-switch v-model="form.enabledFlag" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.details.shards')" prop="shards">
            <BjInput v-model="form.shards" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.details.replicas')" prop="replicas">
            <BjInput v-model="form.replicas" :maxlength="MAX_LENGTH.DEFAULT" placeholder="" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createdByText')">
            <BjInput :maxlength="MAX_LENGTH.DEFAULT" placeholder="" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.updateUser')">
            <BjInput :maxlength="MAX_LENGTH.DEFAULT" placeholder="" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.lastUpdateDate')">
            <BjInput :maxlength="MAX_LENGTH.DEFAULT" placeholder="" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjInput :maxlength="MAX_LENGTH.DEFAULT" placeholder="" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <BjDivider
      >{{ $t('SettingIndexesList.details.syncField') }}
      <template slot="button">
        <el-button type="primary" @click="onAdd">{{ $t('addText') }}</el-button>
      </template>
    </BjDivider>

    <el-table border :data="form.indexFieldList">
      <el-table-column :label="$t('SettingIndexesList.details.fieldName')" align="center" prop="fieldName">
        <template slot-scope="scope">
          <BjInput
            v-model="scope.row.fieldName"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('inputText')"
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('SettingIndexesList.details.fieldType')" align="center" prop="fieldType">
        <template slot-scope="scope">
          <BjInput
            v-model="scope.row.fieldType"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('inputText')"
            @blur="checkType(scope.$index)"
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('SettingIndexesList.details.analyzerFlag')" align="center" prop="analyzerFlag">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.analyzerFlag"
            :disabled="scope.row.fieldType !== 'Text'"
            :placeholder="$t('chooseText')"
            @change="selection(scope.$index)"
          >
            <el-option
              v-for="item in STATUS_YES_NUM"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="$t('SettingIndexesList.details.filedAnalyzerCode')" align="center" prop="filedAnalyzerCode">
        <template slot-scope="scope">
          <BjInput
            v-model="scope.row.filedAnalyzerCode"
            :maxlength="MAX_LENGTH.DEFAULT"
            :disabled="scope.row.analyzerFlag !== 1"
            :placeholder="$t('inputText')"
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('SettingIndexesList.details.pkFlag')" align="center" prop="pkFlag">
        <template slot-scope="scope">
          <el-select v-model="scope.row.pkFlag" :placeholder="$t('chooseText')">
            <el-option
              v-for="item in STATUS_YES_NUM"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operationText')" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="onDelete(scope.$index)">{{ $t('delText') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt20" style="text-align: right">
      <el-pagination
        :current-page="pageNun"
        :page-sizes="PAGE_SIZES"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { settingApi } from '@/api';
import { STATUS_YES_NUM, PAGE_SIZES } from '@/utils/constants';
export default {
  mixins: [viewMiXin],
  data() {
    return {
      colSpan: 8,
      STATUS_YES_NUM,
      PAGE_SIZES,
      data: [],
      form: {
        enabledFlag: 0,
        indexFieldList: [],
      },
      rules: {
        indexCode: [{ required: true, message: this.$t('SettingIndexesList.details.msgRulesText'), trigger: 'blur' }],
      },
      pageNun: 1,
      pageSize: 15,
      total: 0,
    };
  },
  created() {
    if (this.$route.query.form) {
      this.form = JSON.parse(this.$route.query.form);
      settingApi.getIndexesDetail({ indexId: this.form.indexId }).then(res => {
        this.form.indexFieldList = res;
        this.total = this.form.indexFieldList.length;
      });
    }
  },
  methods: {
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
    onAdd() {
      const obj = {
        fieldName: '',
        fieldType: '',
        analyzerFlag: 0,
        filedAnalyzerCode: '',
        pkFlag: '',
      };
      this.form.indexFieldList.push(obj);
    },
    onDelete(index) {
      this.form.indexFieldList.splice(index, 1);
    },
    checkType(index) {
      if (this.form.indexFieldList[index].fieldType !== 'Text') {
        this.form.indexFieldList[index].analyzerFlag = 0;
      }
    },
    selection(index) {
      if (this.form.indexFieldList[index].analyzerFlag !== 1) {
        this.form.indexFieldList[index].filedAnalyzerCode = '';
      }
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        const boolean = this.form.indexFieldList.every(
          item => item.fieldName && item.fieldType !== '' && item.pkFlag,
        );
        if (boolean) {
          this.$alert(this.$t('SettingIndexesList.details.alertMsgText'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            callback: action => {},
          });
          return;
        }
        settingApi.getIndexesAdd(this.form).then(res => {
          if (!res.failed) {
            // if (this.form.indexId) {
            //   return;
            // }
            // this.form = {
            //   enabledFlag: 0,
            //   indexFieldList: [],
            // };

            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.complete('SettingIndexesConfigListIndex');
            }, 500);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
